import React from 'react';
import { Navigate } from 'react-router';
import { useUser } from '@repo/hooks/useUser';
import { useFilterRestoreRedirect } from '@repo/hooks/useFilterRestoreRedirect';

export interface FilterRestoreGateProps {
  /** Stable identifier for the table (must match the `tableKey` used with `useFilterPreference`). */
  tableKey: string;
  children: React.ReactNode;
}

/**
 * Restores a user's saved sort/filters on a bare table URL BEFORE the wrapped table mounts.
 * While a restore redirect is pending, `children` (the table) is never rendered, so the table
 * and its Pagination only mount once the URL already carries the restored params — restoring
 * after the table mounts races Pagination's page-reset effect and gets stripped.
 */
export const FilterRestoreGate = ({ tableKey, children }: FilterRestoreGateProps) => {
  const user = useUser();
  const restore = useFilterRestoreRedirect({ tableKey, userId: user.id });

  if (restore) {
    return <Navigate to={restore} replace />;
  }

  return <>{children}</>;
};
